import React, { useState, useEffect, useMemo } from 'react'; // Removed useRef, added useMemo
import LeafletMapComponent from './LeafletMapComponent'; // Import the external component

const EuropeCardGame = () => {
  const [countries, setCountries] = useState([]);
  const [flippedCards, setFlippedCards] = useState({});
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [resetView, setResetView] = useState(false);
  // const mapRef = useRef(null); // Removed unused ref

  // European countries data with Italian names, capitals, flags, and ISO codes
  // Wrapped in useMemo to prevent recreation on every render
  const europeData = useMemo(() => [
    { name: 'Albania', capital: 'Tirana', flag: '🇦🇱', iso: 'ALB' },
    { name: 'Andorra', capital: 'Andorra la Vella', flag: '🇦🇩', iso: 'AND' },
    { name: 'Austria', capital: 'Vienna', flag: '🇦🇹', iso: 'AUT' },
    { name: 'Bielorussia', capital: 'Minsk', flag: '🇧🇾', iso: 'BLR' },
    { name: 'Belgio', capital: 'Bruxelles', flag: '🇧🇪', iso: 'BEL' },
    { name: 'Bosnia ed Erzegovina', capital: 'Sarajevo', flag: '🇧🇦', iso: 'BIH' },
    { name: 'Bulgaria', capital: 'Sofia', flag: '🇧🇬', iso: 'BGR' },
    { name: 'Croazia', capital: 'Zagabria', flag: '🇭🇷', iso: 'HRV' },
    { name: 'Cipro', capital: 'Nicosia', flag: '🇨🇾', iso: 'CYP' },
    { name: 'Repubblica Ceca', capital: 'Praga', flag: '🇨🇿', iso: 'CZE' },
    { name: 'Danimarca', capital: 'Copenaghen', flag: '🇩🇰', iso: 'DNK' },
    { name: 'Estonia', capital: 'Tallinn', flag: '🇪🇪', iso: 'EST' },
    { name: 'Finlandia', capital: 'Helsinki', flag: '🇫🇮', iso: 'FIN' },
    { name: 'Francia', capital: 'Parigi', flag: '🇫🇷', iso: 'FRA' },
    { name: 'Germania', capital: 'Berlino', flag: '🇩🇪', iso: 'DEU' },
    { name: 'Grecia', capital: 'Atene', flag: '🇬🇷', iso: 'GRC' },
    { name: 'Ungheria', capital: 'Budapest', flag: '🇭🇺', iso: 'HUN' },
    { name: 'Islanda', capital: 'Reykjavik', flag: '🇮🇸', iso: 'ISL' },
    { name: 'Irlanda', capital: 'Dublino', flag: '🇮🇪', iso: 'IRL' },
    { name: 'Italia', capital: 'Roma', flag: '🇮🇹', iso: 'ITA' },
    { name: 'Lettonia', capital: 'Riga', flag: '🇱🇻', iso: 'LVA' },
    { name: 'Liechtenstein', capital: 'Vaduz', flag: '🇱🇮', iso: 'LIE' },
    { name: 'Lituania', capital: 'Vilnius', flag: '🇱🇹', iso: 'LTU' },
    { name: 'Lussemburgo', capital: 'Lussemburgo', flag: '🇱🇺', iso: 'LUX' },
    { name: 'Malta', capital: 'La Valletta', flag: '🇲🇹', iso: 'MLT' },
    { name: 'Moldavia', capital: 'Chisinau', flag: '🇲🇩', iso: 'MDA' },
    { name: 'Monaco', capital: 'Monaco', flag: '🇲🇨', iso: 'MCO' },
    { name: 'Montenegro', capital: 'Podgorica', flag: '🇲🇪', iso: 'MNE' },
    { name: 'Paesi Bassi', capital: 'Amsterdam', flag: '🇳🇱', iso: 'NLD' },
    { name: 'Macedonia del Nord', capital: 'Skopje', flag: '🇲🇰', iso: 'MKD' },
    { name: 'Norvegia', capital: 'Oslo', flag: '🇳🇴', iso: 'NOR' },
    { name: 'Polonia', capital: 'Varsavia', flag: '🇵🇱', iso: 'POL' },
    { name: 'Portogallo', capital: 'Lisbona', flag: '🇵🇹', iso: 'PRT' },
    { name: 'Romania', capital: 'Bucarest', flag: '🇷🇴', iso: 'ROU' },
    { name: 'Russia', capital: 'Mosca', flag: '🇷🇺', iso: 'RUS' },
    { name: 'San Marino', capital: 'San Marino', flag: '🇸🇲', iso: 'SMR' },
    { name: 'Serbia', capital: 'Belgrado', flag: '🇷🇸', iso: 'SRB' },
    { name: 'Slovacchia', capital: 'Bratislava', flag: '🇸🇰', iso: 'SVK' },
    { name: 'Slovenia', capital: 'Lubiana', flag: '🇸🇮', iso: 'SVN' },
    { name: 'Spagna', capital: 'Madrid', flag: '🇪🇸', iso: 'ESP' },
    { name: 'Svezia', capital: 'Stoccolma', flag: '🇸🇪', iso: 'SWE' },
    { name: 'Svizzera', capital: 'Berna', flag: '🇨🇭', iso: 'CHE' },
    { name: 'Ucraina', capital: 'Kiev', flag: '🇺🇦', iso: 'UKR' },
    { name: 'Regno Unito', capital: 'Londra', flag: '🇬🇧', iso: 'GBR' },
    { name: 'Città del Vaticano', capital: 'Città del Vaticano', flag: '🇻🇦', iso: 'VAT' }
  ], []); // Empty dependency array means this runs only once

  // Fisher-Yates shuffle algorithm for random placement
  const shuffleArray = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  };

  // Initialize cards with randomized positions
  useEffect(() => {
    setCountries(shuffleArray(europeData));
  }, [europeData]); // Added europeData to dependency array
  
  // Handle card click - toggle flip state and select country for map
  const handleCardClick = (country) => {
    setFlippedCards(prev => ({
      ...prev,
      [country.name]: !prev[country.name]
    }));
    
    setSelectedCountry(country);
    setResetView(false);
  };

  // Reset all cards and map
  const resetCards = () => {
    setFlippedCards({});
    setSelectedCountry(null);
    setResetView(true);
    setCountries(shuffleArray(europeData));
  };

  // Handle click on a country in the map
  const handleMapCountryClick = (isoCode) => {
    const country = europeData.find(c => c.iso === isoCode);
    if (country) {
      setFlippedCards(prev => ({
        ...prev,
        [country.name]: true // Always flip to show the back
      }));
      setSelectedCountry(country);
      setResetView(false);
    }
  };

  // Card component
  const Card = ({ country, isFlipped }) => {
    return (
      <div 
        className="w-32 h-32 m-2 cursor-pointer perspective-1000" // Reduced card size
        onClick={() => handleCardClick(country)}
      >
        <div className={`relative w-full h-full transition-transform duration-500 transform-style-preserve-3d ${isFlipped ? 'rotate-y-180' : ''}`}>
          {/* Front of card - Country name */}
          <div className="absolute w-full h-full bg-blue-500 flex items-center justify-center text-white font-bold rounded-lg shadow-md backface-hidden text-center p-1"> {/* Added text-center and padding */}
            <span className="text-lg">{country.name}</span> {/* Reduced text size */}
          </div>
          {/* Back of card - Capital and flag */}
          <div className="absolute w-full h-full bg-white p-2 flex flex-col items-center justify-center rounded-lg shadow-md backface-hidden rotate-y-180"> {/* Reduced padding */}
            <div className="text-center">
              <div className="text-4xl mb-1">{country.flag}</div> {/* Reduced flag size and margin */}
              <div className="font-bold text-base">{country.capital}</div> {/* Reduced text size */}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="p-4 flex flex-col h-screen"> {/* Use flex-col and full screen height */}
      {/* Header Section */}
      <div className="mb-4 flex justify-between items-center flex-shrink-0"> {/* Prevent header from shrinking */}
        <h1 className="text-2xl font-bold">Paesi Europei</h1>
        <button 
          onClick={resetCards}
          className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded">
          Mescola Carte
        </button>
      </div>

      {/* Main Content Area (Cards + Map) */}
      <div className="flex flex-grow h-[600px]"> {/* Use flex, grow to fill space, fixed height */}
        
        {/* Cards Section (Left) */}
        <div className="w-1/2 pr-2 overflow-y-auto border border-gray-300 rounded-lg"> {/* Left half, padding, scroll, border */}
          <div className="flex flex-wrap justify-center p-2"> {/* Inner container for cards */}
            {countries.map(country => (
              <Card 
                key={country.name} 
                country={country} 
                isFlipped={flippedCards[country.name]} 
              />
            ))}
          </div>
        </div>

        {/* Map Section (Right) */}
        <div className="w-1/2 pl-2 border border-gray-300 rounded-lg flex flex-col"> {/* Right half, padding, border, flex column */}
          <h2 className="text-xl font-bold p-2 bg-gray-100 rounded-t-lg flex-shrink-0">Mappa dell'Europa</h2> {/* Map title */}
          <div className="flex-grow"> {/* Map container takes remaining space */}
            <LeafletMapComponent 
              selectedCountry={selectedCountry} 
              resetView={resetView} 
              onCountryClick={handleMapCountryClick} // Pass the handler down
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EuropeCardGame;
